import { useAuthMutation } from '#lib/hooks/use-mutation.js';
import {jsonHeaders} from '#lib/helpers/fetch.js';


async function deleteConnection(id, authHeaders) {
    const response = await fetch(`${API_URL}/p/connection`, {
        method: 'DELETE',
        headers: {...jsonHeaders, ...authHeaders},
        body: JSON.stringify({connectionId: id})
    });
    return await response.json();
}

export default function useUnlink(options) {
    return useAuthMutation({mutationFn: deleteConnection, ...options})
}